<!-- FICHA RÁPIDA DE LA LIQUIDACIÓN (FIC-03; Mario, 12-oct). Panel lateral; se abre con FichaLiquidacionService.abrir(). -->
<div *ngIf="codigo" class="fixed inset-0 z-[60] flex justify-end bg-black/30" (click)="cerrar()" (keydown.escape)="cerrar()">
  <aside class="flex h-full w-full max-w-md flex-col overflow-y-auto bg-background shadow-xl" (click)="$event.stopPropagation()"
         role="dialog" aria-modal="true" [attr.aria-label]="'Liquidación ' + codigo">
    <header class="flex items-start justify-between gap-3 border-b border-border px-5 py-4">
      <div class="min-w-0">
        <p class="kb-td-sub m-0">Liquidación al comercio</p>
        <h3 class="m-0 flex items-center gap-1 text-base font-semibold"><span class="font-mono">{{ codigo }}</span><app-copiar [texto]="codigo" etiqueta="la liquidación"></app-copiar></h3>
      </div>
      <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="cerrar()" aria-label="Cerrar">✕</button>
    </header>

    <div class="flex flex-col gap-5 px-5 py-4 text-sm">
      <p *ngIf="cargando" class="kb-td-sub m-0">Leyendo la liquidación…</p>
      <div *ngIf="error" class="kb-aviso-peligro">{{ error }}</div>

      <ng-container *ngIf="f as f">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <app-estampa-comercio [codigo]="f.comercio" [nombre]="f.comercio_nombre" [tam]="32" [conNombre]="true"
                                [sub]="f.modelo === 'COBRANZA' ? 'cobranza' : 'compra de deuda'"></app-estampa-comercio>
          <span class="kb-badge" [ngClass]="claseMarca(marca)">{{ textoMarca }}</span>
        </div>

        <!-- Fechas clave, con quién y cuándo (FIC-01) -->
        <section>
          <h4 class="m-0 mb-2 text-sm font-semibold">Fechas clave</h4>
          <dl class="m-0 grid grid-cols-[110px_1fr] gap-x-3 gap-y-2">
            <dt class="kb-td-sub m-0">Cierre</dt>
            <dd class="m-0"><b>{{ fecha(f.fechas?.cierre?.dia) }}</b>
              <span class="kb-td-sub ml-1 inline-flex items-center gap-1">· <span class="font-mono">{{ f.fechas?.cierre?.codigo }}</span><app-copiar [texto]="f.fechas?.cierre?.codigo" etiqueta="el cierre"></app-copiar></span></dd>

            <dt class="kb-td-sub m-0">Aprobada</dt>
            <dd class="m-0"><ng-container *ngIf="f.fechas?.aprobada as a; else aun"><b>{{ hora(a.en) }}</b>
              <span class="kb-td-sub block">{{ f.fechas?.aprobada?.quien }}<ng-container *ngIf="a.tanda"> · tanda {{ a.tanda }}</ng-container><ng-container *ngIf="a.banda"> · banda {{ a.banda }}</ng-container></span></ng-container></dd>

            <dt class="kb-td-sub m-0">Lote</dt>
            <dd class="m-0"><ng-container *ngIf="f.fechas?.lote as l; else aun"><b>{{ hora(l.en) }}</b>
              <span class="kb-td-sub block">{{ l.quien }}<ng-container *ngIf="l.tasa"> · tasa BCV {{ l.tasa | number:'1.2-2':'es' }}</ng-container></span>
              <span class="inline-flex items-center gap-1 font-mono text-xs">{{ l.codigo }}<app-copiar [texto]="l.codigo" etiqueta="el lote"></app-copiar></span></ng-container></dd>

            <dt class="kb-td-sub m-0">En el banco</dt>
            <dd class="m-0"><ng-container *ngIf="f.fechas?.en_banco as b; else aun"><b>{{ hora(b.en) }}</b><span class="kb-td-sub block">{{ b.quien }}</span></ng-container></dd>

            <ng-container *ngIf="!f.fechas?.no_procesada">
              <dt class="kb-td-sub m-0">Pagada</dt>
              <dd class="m-0"><ng-container *ngIf="f.fechas?.pagada as p; else aun"><b>{{ hora(p.en) }}</b><span class="kb-td-sub block">{{ p.quien }}</span>
                <span class="inline-flex items-center gap-1 font-mono text-xs">ref. {{ f.fechas?.pagada?.referencia || '—' }}<app-copiar [texto]="f.fechas?.pagada?.referencia" etiqueta="la referencia bancaria"></app-copiar></span></ng-container></dd>
            </ng-container>
            <ng-container *ngIf="f.fechas?.no_procesada as n">
              <dt class="kb-td-sub m-0">No procesada</dt>
              <dd class="m-0 kb-texto-peligro"><b>{{ hora(n.en) }}</b><span class="block text-xs">{{ n.quien }} · {{ n.motivo || 'sin motivo' }}</span></dd>
            </ng-container>
          </dl>
          <ng-template #aun><span class="kb-td-sub">Todavía no</span></ng-template>
        </section>

        <!-- Montos y cuenta por pagar -->
        <section>
          <h4 class="m-0 mb-2 text-sm font-semibold">Montos</h4>
          <dl class="m-0 grid grid-cols-[110px_1fr] gap-x-3 gap-y-2">
            <dt class="kb-td-sub m-0">Neto</dt><dd class="m-0 tabular-nums"><b>$ {{ (f.neto || 0) | number:'1.2-2':'es' }}</b></dd>
            <ng-container *ngIf="f.fechas?.pagada?.monto_bs != null"><dt class="kb-td-sub m-0">En bolívares</dt><dd class="m-0 tabular-nums">Bs {{ f.fechas.pagada.monto_bs | number:'1.2-2':'es' }}</dd></ng-container>
            <dt class="kb-td-sub m-0">Cuenta por pagar</dt>
            <dd class="m-0"><span class="inline-flex items-center gap-1 font-mono text-xs">{{ f.cuenta_por_pagar || '—' }}<app-copiar [texto]="f.cuenta_por_pagar" etiqueta="la cuenta por pagar"></app-copiar></span>
              <span class="kb-td-sub" *ngIf="f.saldo != null"> · saldo $ {{ f.saldo | number:'1.2-2':'es' }}</span></dd>
            <ng-container *ngIf="f.contrato"><dt class="kb-td-sub m-0">Contrato</dt><dd class="m-0 font-mono text-xs">{{ f.contrato }}</dd></ng-container>
          </dl>
        </section>

        <!-- Pagarés que entraron -->
        <section *ngIf="f.partidas?.length">
          <h4 class="m-0 mb-2 text-sm font-semibold">Pagarés ({{ f.partidas.length }})</h4>
          <ul class="m-0 flex list-none flex-col gap-1 p-0">
            <li *ngFor="let p of f.partidas" class="flex items-center justify-between gap-2">
              <span class="inline-flex items-center gap-1 font-mono text-xs">{{ p.pagare }}<app-copiar [texto]="p.pagare" etiqueta="el pagaré"></app-copiar></span>
              <span class="tabular-nums">$ {{ (p.neto || 0) | number:'1.2-2':'es' }}</span>
            </li>
          </ul>
        </section>

        <!-- Historia completa -->
        <section *ngIf="f.historia?.length">
          <h4 class="m-0 mb-2 text-sm font-semibold">Historia</h4>
          <ol class="relative m-0 ml-2 list-none space-y-3 border-l-2 border-border py-0 pr-0 pl-5">
            <li class="relative" *ngFor="let h of f.historia">
              <span class="absolute -left-[27px] top-1 h-3 w-3 rounded-full bg-foreground ring-4 ring-background"></span>
              <p class="m-0"><b>{{ ACCION[h.accion] || h.accion }}</b><span class="kb-td-sub ml-2">{{ hora(h.en) }}</span></p>
              <p class="kb-td-sub m-0">{{ h.quien }}<ng-container *ngIf="h.motivo"> · {{ h.motivo }}</ng-container></p>
            </li>
          </ol>
        </section>

        <a class="kb-btn kb-btn-outline kb-btn-sm !w-auto self-start" [routerLink]="['/console/liquidacion/consultas']"
           [queryParams]="{ vista: 'historial', comercio: f.comercio }" (click)="cerrar()">Abrir en Consultas</a>
      </ng-container>
    </div>
  </aside>
</div>
